'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _styledText = require('../../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _proptypes = require('../proptypes');

var _proptypes2 = require('../../util/proptypes');

require('./input-error-wrapper.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-input-error-';

var InputErrorWrapper = function (_Component) {
  _inherits(InputErrorWrapper, _Component);

  function InputErrorWrapper() {
    _classCallCheck(this, InputErrorWrapper);

    return _possibleConstructorReturn(this, (InputErrorWrapper.__proto__ || Object.getPrototypeOf(InputErrorWrapper)).apply(this, arguments));
  }

  _createClass(InputErrorWrapper, [{
    key: 'getError',
    value: function getError() {
      var _props = this.props,
          meta = _props.meta,
          testID = _props.testID,
          error = _props.error;
      var errorMsg = meta && meta.touched && meta.error || error || null;

      if (errorMsg) {
        return _react2.default.createElement(_styledText2.default, {
          className: STYLE_BASE + 'style',
          testid: testID
        }, errorMsg);
      }

      return null;
    }
  }, {
    key: 'renderInputComp',
    value: function renderInputComp() {
      var _props2 = this.props,
          inputComponent = _props2.inputComponent,
          meta = _props2.meta,
          error = _props2.error,
          testid = _props2.testid,
          rest = _objectWithoutProperties(_props2, ['inputComponent', 'meta', 'error', 'testid']);

      var restProps = (0, _omit2.default)(rest, ['autoSelect', 'editable', 'inputComponent', 'onChangeText', 'onSelectionChange', 'onValueChange']);

      var props = _extends({}, restProps, {
        onFocus: this.props.input && this.props.input.onFocus,
        onBlur: this.props.input && this.props.input.onBlur,
        onChange: this.props.onChange || this.props.input && this.props.input.onChange,
        error: error || meta && meta.touched && meta.error || '',
        'data-testid': testid
      });

      return _react2.default.createElement(inputComponent, _extends({}, props));
    }
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _props3 = this.props,
          children = _props3.children,
          meta = _props3.meta,
          error = _props3.error;
      var err = error || meta && meta.touched && meta.error || '';

      if (!children) {
        return null;
      }

      return err ? _react2.default.cloneElement(children, {
        error: err
      }) : children;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props4 = this.props,
          containerClassName = _props4.containerClassName,
          inputComponent = _props4.inputComponent,
          style = _props4.style;
      /*
       NOTE(JG): We are not going to reduce the props here, instead let the lower
       level component decide what props it will ignore from this wrapper/parent.
       */

      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + 'base-wrapper', true), _defineProperty(_classNames, containerClassName, !!containerClassName), _classNames)),
        style: style
      }, inputComponent ? this.renderInputComp() : this.renderChild(), this.getError());
    }
  }]);

  return InputErrorWrapper;
}(_react.Component);

InputErrorWrapper.propTypes = _extends({}, _proptypes.INPUT_COMP_PROP, {
  style: _proptypes2.STYLE_PROP
});
exports.default = InputErrorWrapper;